import { useState } from 'react';
import { faqData } from '@/mocks/comics';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            关于韩漫大全，你想知道的都在这里
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer transition-colors duration-200 hover:bg-background-100"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <div className={`flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full transition-all duration-300 ${
                  openIndex === index
                    ? 'bg-primary-500 text-background-50 rotate-45'
                    : 'bg-background-100 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}